// การ์ดหัวข้อตั้งค่า — กดแล้วเนื้อหาเปิดเป็นแผงสไลด์จากขวา
//
// ของเดิม "ย้าย element" ของ .cfg-body เข้าไปใน drawer เพื่อไม่ให้ event listener หลุด
// React ย้าย subtree ข้าม parent ไม่ได้โดยไม่ unmount (state ในฟอร์มจะหาย) จึงกลับด้าน:
// render เนื้อหาไว้ใน drawer เสมอ แล้วซ่อนอันที่ไม่ได้เปิด — component ยัง mount อยู่
// ค่าที่ผู้ใช้กรอกไว้จึงไม่หายเวลาปิด-เปิดแผง (CSS เดิมซ่อน .cfg-body ในการ์ดอยู่แล้ว)
import { useEffect, useState, type ReactNode } from "react";
import { IconChevronDown } from "@shared/ui/icons";
import { cn } from "@shared/lib/utils";

export type CfgSection = {
  id: string;
  title: string;
  desc: string;
  status?: ReactNode;
  body: ReactNode;
};

export function SectionCards({ sections }: { sections: CfgSection[] }) {
  const [openId, setOpenId] = useState<string | null>(null);
  const open = sections.find((s) => s.id === openId) ?? null;

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpenId(null);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <div className="cfg-sections">
        {sections.map((s, i) => (
          <section
            key={s.id}
            className={cn("cfg-card", s.id === openId && "open-in-drawer")}
            data-sec={s.id}
          >
            <button className="cfg-head" type="button" onClick={() => setOpenId(s.id)}>
              <span className="cfg-num">{i + 1}</span>
              <span className="cfg-titles">
                <span className="cfg-title">{s.title}</span>
                <span className="cfg-desc">{s.desc}</span>
              </span>
              <span className="cfg-status">{s.status}</span>
              <span className="cfg-chev">
                <IconChevronDown />
              </span>
            </button>
          </section>
        ))}
      </div>

      <div
        className={cn("drawer-overlay", open && "open")}
        id="sec-drawer-overlay"
        onClick={() => setOpenId(null)}
      />
      <aside className={cn("drawer", open && "open")} id="sec-drawer">
        <div className="drawer-head">
          <h3>{open?.title ?? ""}</h3>
          <button type="button" className="icon-btn" title="ปิด" onClick={() => setOpenId(null)}>
            ✕
          </button>
        </div>
        <div className="drawer-body">
          {sections.map((s) => (
            <div key={s.id} className="cfg-body" hidden={s.id !== openId}>
              {s.body}
            </div>
          ))}
        </div>
      </aside>
    </>
  );
}
